import { render, staticRenderFns } from "./FileUploaderImg.vue?vue&type=template&id=fd80c3f2&scoped=true"
import script from "./FileUploaderImg.vue?vue&type=script&lang=js"
export * from "./FileUploaderImg.vue?vue&type=script&lang=js"
import style0 from "./FileUploaderImg.vue?vue&type=style&index=0&id=fd80c3f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd80c3f2",
  null
  
)

export default component.exports